import React, { useState } from "react";
import { Container, Row, Col, Card, Badge, Button, Navbar, Nav, Modal, Form, Alert } from "react-bootstrap";
import { Formik } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./app.css";

const App = () => {
   const [selectedEvent, setSelectedEvent] = useState(null);
   const [selectedMedia, setSelectedMedia] = useState(null);
   const [showMediaModal, setShowMediaModal] = useState(false);

   // Media files from assets/images/pics
   const mediaFiles = [
      { name: "IMG_0668.MOV", type: "video", path: "/assets/images/pics/IMG_0668.MOV" },
      { name: "PXL_20221016_213035997.jpg", type: "image", path: "/assets/images/pics/PXL_20221016_213035997.jpg" },
      { name: "PXL_20221018_010832909.jpg", type: "image", path: "/assets/images/pics/PXL_20221018_010832909.jpg" },
      { name: "PXL_20221027_183009542.LS.mp4", type: "video", path: "/assets/images/pics/PXL_20221027_183009542.LS.mp4" },
      { name: "PXL_20230101_201532346.jpg", type: "image", path: "/assets/images/pics/PXL_20230101_201532346.jpg" },
      { name: "PXL_20230101_212652192.MP.jpg", type: "image", path: "/assets/images/pics/PXL_20230101_212652192.MP.jpg" },
      { name: "PXL_20230102_003130102.jpg", type: "image", path: "/assets/images/pics/PXL_20230102_003130102.jpg" },
      { name: "PXL_20230102_034841291.jpg", type: "image", path: "/assets/images/pics/PXL_20230102_034841291.jpg" },
      { name: "PXL_20230106_014338900.TS.mp4", type: "video", path: "/assets/images/pics/PXL_20230106_014338900.TS.mp4" },
      { name: "PXL_20230116_213016483.jpg", type: "image", path: "/assets/images/pics/PXL_20230116_213016483.jpg" },
      { name: "PXL_20230331_054655644.TS.mp4", type: "video", path: "/assets/images/pics/PXL_20230331_054655644.TS.mp4" },
      { name: "PXL_20230403_150101664.jpg", type: "image", path: "/assets/images/pics/PXL_20230403_150101664.jpg" },
      { name: "PXL_20230410_004133437.jpg", type: "image", path: "/assets/images/pics/PXL_20230410_004133437.jpg" },
      { name: "PXL_20230412_025157398.jpg", type: "image", path: "/assets/images/pics/PXL_20230412_025157398.jpg" },
      { name: "PXL_20230510_225332672.TS.mp4", type: "video", path: "/assets/images/pics/PXL_20230510_225332672.TS.mp4" },
      { name: "PXL_20230729_043617425.jpg", type: "image", path: "/assets/images/pics/PXL_20230729_043617425.jpg" }
   ];

   const handleMediaClick = (media) => {
      setSelectedMedia(media);
      setShowMediaModal(true);
   };

   // Sample events data - you can replace this with real data
   const upcomingEvents = [
     
   ];

   const formatDate = (dateString) => {
      return new Date(dateString).toLocaleDateString('en-US', {
         year: 'numeric',
         month: 'long',
         day: 'numeric'
      });
   };

   return (
      <div className="appcontainer">
         
         <Navbar bg="dark" variant="dark" expand="lg" className="mb-4" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
            <Container>
               <Navbar.Brand href="#home" className="fw-bold">Misgnomer</Navbar.Brand>
               <Navbar.Toggle aria-controls="basic-navbar-nav" />
               <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="ms-auto">
                     <Nav.Link href="#concept">About</Nav.Link>
                     <Nav.Link href="#gallery">Gallery</Nav.Link>
                     <Nav.Link href="#events">Events</Nav.Link>
                     <Nav.Link href="#contact">Host the Machine</Nav.Link>
                  </Nav>
               </Navbar.Collapse>
            </Container>
         </Navbar>

         <Container fluid="lg">
            {/* Hero Section */}
            <Row className="text-center mb-5 py-5">
               <Col>
                  <h1 className="display-3 mb-4 fw-bold">Misgnomer</h1>
                  <p className="lead fs-4 mb-4">Multiplayer Interactive Diorama Adventure</p>
                  <Badge bg="primary" className="fs-6 px-3 py-2">4 Player Co-op • Gnome Warriors • Octopus Boss Battle</Badge>
               </Col>
            </Row>

            {/* How to Play Video Section */}
            <section className="mb-5">
               <Row>
                  <Col lg={8} className="mx-auto">
                     <Card bg="dark" text="light" className="border-0 section-card">
                        <Card.Body className="p-4">
                           <h3 className="text-center mb-4">How to Connect & Play</h3>
                           <div className="video-container mb-3">
                              <video 
                                 src="/assets/images/pics/mainVideo.mp4"
                                 controls
                                 className="w-100"
                                 style={{ 
                                    maxHeight: '400px', 
                                    borderRadius: '8px',
                                    backgroundColor: '#000'
                                 }}
                                 poster=""
                              >
                                 Your browser does not support the video tag.
                              </video>
                           </div>
                           <p className="text-center text-light mb-0">
                              Connect your phone as a controller and join the multiplayer gnome battle against the mighty octopus!
                           </p>
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
            </section>

            {/* Concept Section */}
            <section id="concept" className="mb-5">
               <Row>
                  <Col lg={10} className="mx-auto">
                     <Card bg="dark" text="light" className="border-0 section-card">
                        <Card.Body className="p-4">
                           <h2 className="text-center mb-4 section-title">The Adventure</h2>
                           <p className="fs-5 mb-4 text-center">
                              <strong>Misgnomer</strong> is an evolved multiplayer interactive diorama that builds upon everything learned from "How to be a Cat." 
                              This scalable experience supports multiple simultaneous games and brings friends together for epic gnome battles against a formidable octopus foe.
                           </p>
                           
                           <Row className="g-4">
                              <Col md={6}>
                                 <div className="feature-box">
                                    <h4 className="text-primary mb-3">The Battle</h4>
                                    <ul className="list-unstyled">
                                       <li className="mb-2">• Choose from 4 unique gnome warriors</li>
                                       <li className="mb-2">• Team up with friends in multiplayer mode</li>
                                       <li className="mb-2">• Face off against a mighty octopus boss</li>
                                       <li className="mb-2">• Strategic combat in a miniature world</li>
                                    </ul>
                                 </div>
                              </Col>
                              <Col md={6}>
                                 <div className="feature-box">
                                    <h4 className="text-warning mb-3">Enhanced Features</h4>
                                    <ul className="list-unstyled">
                                       <li className="mb-2">• Scalable multiplayer architecture</li>
                                       <li className="mb-2">• Multiple simultaneous game sessions</li>
                                       <li className="mb-2">• QR code mobile controllers</li>
                                       <li className="mb-2">• Two identical diorama installations</li>
                                    </ul>
                                 </div>
                              </Col>
                           </Row>

                           <div className="text-center mt-4">
                              <Badge bg="info" className="me-2">Multiplayer</Badge>
                              <Badge bg="success" className="me-2">Scalable Tech</Badge>
                              <Badge bg="warning" className="me-2">Dual Installation</Badge>
                              <Badge bg="danger">Boss Battle</Badge>
                           </div>
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
            </section>

            {/* Gallery Section */}
            <section id="gallery" className="mb-5">
               <Row>
                  <Col>
                     <h2 className="text-center mb-4 section-title">Gallery</h2>
                     <p className="text-center text-light mb-5">
                        Behind the scenes photos and videos from the creation and exhibition of "Misgnomer"
                     </p>
                  </Col>
               </Row>
               
               {mediaFiles.length > 0 ? (
                  <Row className="g-3 justify-content-center">
                     {mediaFiles.map((media, index) => (
                        <Col xl={3} lg={4} md={6} sm={6} xs={12} key={index} className="d-flex">
                           <Card 
                              bg="dark" 
                              text="light" 
                              className="media-card h-100 w-100 shadow"
                              onClick={() => handleMediaClick(media)}
                              style={{ cursor: 'pointer' }}
                           >
                              <div className="media-thumbnail">
                                 {media.type === 'image' ? (
                                    <img 
                                       src={media.path} 
                                       alt={`Gallery item ${index + 1}`}
                                       className="card-img-top"
                                       style={{ height: '200px', objectFit: 'cover' }}
                                    />
                                 ) : (
                                    <div className="video-thumbnail">
                                       <video 
                                          src={media.path}
                                          className="card-img-top"
                                          style={{ height: '200px', objectFit: 'cover' }}
                                          muted
                                       />
                                       <div className="video-overlay">
                                          <div className="play-button">▶</div>
                                       </div>
                                    </div>
                                 )}
                              </div>
                              <Card.Body className="p-2">
                                 <Card.Text className="small text-light mb-0">
                                    {media.type === 'video' ? '🎥 Video' : '📷 Photo'}
                                 </Card.Text>
                              </Card.Body>
                           </Card>
                        </Col>
                     ))}
                  </Row>
               ) : (
                  <Row>
                     <Col className="text-center">
                        <Card bg="dark" text="light" className="border-0 section-card">
                           <Card.Body className="p-5">
                              <h4>Gallery Coming Soon</h4>
                              <p className="text-light">Photos and videos will be added here to showcase the Misgnomer experience!</p>
                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
               )}
            </section>

            {/* Events Section */}
            <section id="events" className="mb-5">
               <Row>
                  <Col>
                     <h2 className="text-center mb-4 section-title">Upcoming Exhibitions</h2>
                     <p className="text-center text-light mb-5">
                        Find out where you can experience "Misgnomer" next
                     </p>
                  </Col>
               </Row>

               {upcomingEvents.length > 0 ? (
                  <Row className="g-4">
                     {upcomingEvents.map((event) => (
                        <Col lg={4} md={6} className="mb-4" key={event.id}>
                           <Card 
                              bg="dark" 
                              text="light" 
                              className="h-100 border-0 event-card section-card"
                              onClick={() => setSelectedEvent(event)}
                           >
                              <Card.Body className="d-flex flex-column">
                                 <div className="mb-3">
                                    <Badge bg="success" className="mb-2">Upcoming</Badge>
                                    <Card.Title className="h5">{event.title}</Card.Title>
                                 </div>
                                 
                                 <div className="mb-3">
                                    <p className="mb-1"><strong>📍 {event.venue}</strong></p>
                                    <p className="text-light mb-1">{event.location}</p>
                                    <p className="text-primary mb-0">
                                       {formatDate(event.date)} - {formatDate(event.endDate)}
                                    </p>
                                 </div>
                                 
                                 <p className="flex-grow-1">{event.description}</p>
                                 
                                 <Button variant="outline-primary" size="sm" className="mt-auto">
                                    Learn More
                                 </Button>
                              </Card.Body>
                           </Card>
                        </Col>
                     ))}
                  </Row>
               ) : (
                  <Row>
                     <Col className="text-center">
                        <Card bg="dark" text="light" className="border-0 section-card">
                           <Card.Body className="p-5">
                              <h4>No Upcoming Events</h4>
                              <p className="text-light">Check back soon for new exhibition announcements!</p>
                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
               )}
            </section>

            {/* Contact Section */}
            <section id="contact" className="mb-5">
               <Row>
                  <Col lg={8} className="mx-auto">
                     <Card bg="dark" text="light" className="border-0 section-card">
                        <Card.Body className="p-4">
                           <h2 className="text-center mb-4 section-title">Host Misgnomer</h2>
                           <p className="fs-5 mb-4 text-center">
                              Interested in hosting "Misgnomer" at your venue? This multiplayer diorama experience 
                              is perfect for events that want to engage groups of visitors in collaborative gameplay.
                           </p>

                           <Formik
                              initialValues={{ 
                                 email: '', 
                                 subject: '', 
                                 message: '',
                                 organization: ''
                              }}
                              validate={(values) => {
                                 const errors = {};
                                 if (!values.email) {
                                    errors.email = 'Required';
                                 } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                                    errors.email = 'Invalid email address';
                                 }
                                 if (!values.subject) {
                                    errors.subject = 'Required';
                                 }
                                 if (!values.message) {
                                    errors.message = 'Required';
                                 }
                                 if (!values.organization) {
                                    errors.organization = 'Required';
                                 }
                                 return errors;
                              }}
                              onSubmit={(values, { setSubmitting, setStatus }) => {
                                 const options = {
                                    method: "POST",
                                    headers: {
                                       "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                       sender: values.email,
                                       content: `Organization: ${values.organization}\n\nMessage: ${values.message}`,
                                       subject: values.subject
                                    }),
                                 };
                                 fetch('/sendMessage', options)
                                    .then(response => response.json())
                                    .then(data => {
                                       console.log("Message sent successfully");
                                       setStatus({ type: 'success', message: 'Message sent successfully! I\'ll get back to you soon.' });
                                       setSubmitting(false);
                                    })
                                    .catch(error => {
                                       console.error('Error:', error);
                                       setStatus({ type: 'error', message: 'Failed to send message. Please try again.' });
                                       setSubmitting(false);
                                    });
                              }}
                           >
                              {({ isSubmitting, status, handleSubmit, handleChange, handleBlur, values, errors, touched }) => (
                                 <Form onSubmit={handleSubmit}>
                                    {status && (
                                       <Alert variant={status.type === 'success' ? 'success' : 'danger'} className="mb-3">
                                          {status.message}
                                       </Alert>
                                    )}
                                    
                                    <Row className="g-3">
                                       <Col md={6}>
                                          <Form.Group>
                                             <Form.Label>Organization/Venue Name</Form.Label>
                                             <Form.Control
                                                type="text"
                                                name="organization"
                                                placeholder="Your venue or organization name"
                                                value={values.organization}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.organization && errors.organization}
                                                className="bg-dark text-light border-secondary"
                                             />
                                             <Form.Control.Feedback type="invalid">
                                                {errors.organization}
                                             </Form.Control.Feedback>
                                          </Form.Group>
                                       </Col>
                                       <Col md={6}>
                                          <Form.Group>
                                             <Form.Label>Email Address</Form.Label>
                                             <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="your@email.com"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.email && errors.email}
                                                className="bg-dark text-light border-secondary"
                                             />
                                             <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                             </Form.Control.Feedback>
                                          </Form.Group>
                                       </Col>
                                    </Row>
                                    
                                    <Row className="g-3 mt-2">
                                       <Col>
                                          <Form.Group>
                                             <Form.Label>Subject</Form.Label>
                                             <Form.Control
                                                type="text"
                                                name="subject"
                                                placeholder="Misgnomer exhibition inquiry"
                                                value={values.subject}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.subject && errors.subject}
                                                className="bg-dark text-light border-secondary"
                                             />
                                             <Form.Control.Feedback type="invalid">
                                                {errors.subject}
                                             </Form.Control.Feedback>
                                          </Form.Group>
                                       </Col>
                                    </Row>
                                    
                                    <Row className="g-3 mt-2">
                                       <Col>
                                          <Form.Group>
                                             <Form.Label>Message</Form.Label>
                                             <Form.Control
                                                as="textarea"
                                                rows={4}
                                                name="message"
                                                placeholder="Tell me about your venue, expected group sizes, event dates, and any specific requirements..."
                                                value={values.message}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.message && errors.message}
                                                className="bg-dark text-light border-secondary"
                                             />
                                             <Form.Control.Feedback type="invalid">
                                                {errors.message}
                                             </Form.Control.Feedback>
                                          </Form.Group>
                                       </Col>
                                    </Row>
                                    
                                    <div className="text-center mt-4">
                                       <Button 
                                          variant="primary" 
                                          type="submit" 
                                          disabled={isSubmitting}
                                          size="lg"
                                       >
                                          {isSubmitting ? 'Sending...' : 'Send Inquiry'}
                                       </Button>
                                    </div>
                                 </Form>
                              )}
                           </Formik>
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
            </section>

            {/* Footer */}
            <Row className="mt-5 pt-4 border-top border-secondary">
               <Col className="text-center">
                  <p className="text-light">
                     "Misgnomer" is a multiplayer interactive diorama that can only be experienced in person.
                     <br />
                     Gather your friends and battle the octopus together!
                  </p>
               </Col>
            </Row>
         </Container>

         {/* Media Modal */}
         <Modal 
            show={showMediaModal} 
            onHide={() => setShowMediaModal(false)} 
            size="lg" 
            centered
            className="media-modal"
         >
            <Modal.Header closeButton className="bg-dark text-light border-secondary">
               <Modal.Title>
                  {selectedMedia?.type === 'video' ? '🎥 Video' : '📷 Photo'}
               </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark p-0">
               {selectedMedia && (
                  <div className="modal-media-container">
                     {selectedMedia.type === 'image' ? (
                        <img 
                           src={selectedMedia.path} 
                           alt="Gallery item"
                           className="img-fluid w-100"
                           style={{ maxHeight: '70vh', objectFit: 'contain' }}
                        />
                     ) : (
                        <video 
                           src={selectedMedia.path}
                           controls
                           className="w-100"
                           style={{ maxHeight: '70vh' }}
                           autoPlay
                        />
                     )}
                  </div>
               )}
            </Modal.Body>
         </Modal>
      </div>
   );
};

export default App;
